import { IElementType, IElementTypeHint, isIElementAreaSection, isIElementWithTypeAndHint } from "@faro-lotv/ielement-types";
import { isValidUrl } from "@utils/url-utils";

/**
 * @returns True iff the IElement is a markup image
 * @param element IElement
 */
export function isIElementMarkupImage(element) {
  return isIElementWithTypeAndHint(element, IElementType.img2d, IElementTypeHint.markupIssueImage);
}

/**
 * @returns True iff the IElement is a Area Section with a valid slideNodesUrl property
 * @param element IElement
 */
export function isIElementAreaSectionWithUrl(element) {
  if (!isIElementAreaSection(element)) {
    return false;
  }
  const slideNodesUrl = element.metaDataMap?.slideNodesUrl;
  return isValidUrl(slideNodesUrl);
}

/**
 * @returns True if the iElement is a IElementMarkup with TypeHint Markup
 * @param iElement The element to check
 */
export function isIElementMarkupWithTypeHint(iElement) {
  return isIElementWithTypeAndHint(iElement, IElementType.markup, IElementTypeHint.markup);
}

/**
 * @returns whether the IElement if of type IElementGroup with type hint Attachments
 * @param element IElement
 */
export function isIElementAttachmentsGroup(element) {
  return isIElementWithTypeAndHint(element, IElementType.group, IElementTypeHint.attachments);
}